import {enUS, fr, es, de, ja, pt, it, nl, sv, hu} from 'date-fns/locale';


export const SUPPORTED_LANGUAGES = [
  'en',
  'fr-CA',
  'es-419',
  'it',
  'fr',
  'es',
  'de',
  'hu',
  'ja',
  'nl',
  'pt',
  'sv',
] as const;

export const languageMenuOptions = [
  {label: 'English', key: 'en'},
  {label: 'Français canadien', key: 'fr-CA'},
  {label: 'Español latinoamericano', key: 'es-419'},
  {label: 'Italiano', key: 'it'},
  {label: 'Français', key: 'fr'},
  {label: 'Español', key: 'es'},
  {label: 'Deutsch', key: 'de'},
  {label: 'Magyar', key: 'hu'},
  {label: '日本語', key: 'ja'},
  {label: 'Nederlands', key: 'nl'},
  {label: 'Português', key: 'pt'},
  {label: 'Svenska', key: 'sv'},
] as const;

export const localeFormats = {
  // English (US) - 12-hour format
  en: {
    formatStr: 'MM/dd/yyyy hh:mm a',
    formatStrMoment: 'MM/DD/YYYY hh:mm A',
    locale: enUS,
  },
  // German - 24-hour format
  de: {
    formatStr: 'dd.MM.yyyy HH:mm',
    formatStrMoment: 'DD.MM.YYYY HH:mm',
    locale: de,
  },
  // Spanish (Latin America) - 24-hour format
  'es-419': {
    formatStr: 'dd/MM/yyyy HH:mm',
    formatStrMoment: 'DD/MM/YYYY HH:mm',
    locale: es,
  },
  // Spanish (Spain) - 24-hour format
  es: {
    formatStr: 'dd/MM/yyyy HH:mm',
    formatStrMoment: 'DD/MM/YYYY HH:mm',
    locale: es,
  },
  // French (Canada) - 24-hour format
  'fr-CA': {
    formatStr: 'yyyy-MM-dd HH:mm',
    formatStrMoment: 'YYYY-MM-DD HH:mm',
    locale: fr,
  },
  // French (France) - 24-hour format
  fr: {
    formatStr: 'dd/MM/yyyy HH:mm',
    formatStrMoment: 'DD/MM/YYYY HH:mm',
    locale: fr,
  },
  // Hungarian - 24-hour format
  hu: {
    formatStr: 'yyyy.MM.dd. HH:mm',
    formatStrMoment: 'YYYY.MM.DD. HH:mm',
    locale: hu,
  },
  // Italian - 24-hour format
  it: {
    formatStr: 'dd/MM/yyyy HH:mm',
    formatStrMoment: 'DD/MM/YYYY HH:mm',
    locale: it,
  },
  // Japanese - 24-hour format with Japanese characters
  ja: {
    formatStr: 'yyyy年MM月dd日 HH:mm',
    formatStrMoment: 'YYYY年MM月DD日 HH:mm',
    locale: ja,
  },
  // Dutch - 24-hour format
  nl: {
    formatStr: 'dd-MM-yyyy HH:mm',
    formatStrMoment: 'DD-MM-YYYY HH:mm',
    locale: nl,
  },
  // Portuguese - 24-hour format
  pt: {
    formatStr: 'dd/MM/yyyy HH:mm',
    formatStrMoment: 'DD/MM/YYYY HH:mm',
    locale: pt,
  },
  // Swedish - 24-hour format
  sv: {
    formatStr: 'yyyy-MM-dd HH:mm',
    formatStrMoment: 'YYYY-MM-DD HH:mm',
    locale: sv,
  },
} as const;

export type LocaleKey = keyof typeof localeFormats;
